import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketKuperApi from '../../../API/market/kuper-api';
import { TYPE_BUTTONS } from '../../../constans';
import styles from './styles.module.scss';
import KuperTable from './Table';
import { Content } from '../../../components/Basic/Global';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import MarketProvidersDateUpdate from '../../../components/Markets/Blocks/MarketProvidersDateUpdate';

const KuperPage = () => {
  const dispatch = useDispatch();

  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [providerData, setProviderData] = useState({ status_stock: '', date_stock_update: null });

  const [market, setMarket] = useState("kuper1");
  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);


  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    if (provider) {
      console.log(provider);
      setProviderData(provider.markets_update?.['kuper']);
    }
  }, [provider]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <WhiteBlock title="Управление" title_bold={`Купер`} style={{ margin: '10px 0' }} minimize={true}>
          <Row style={{ alignItems: 'stretch' }}>
            <Column className={styles.stosks_column}>
              <Row style={{ alignItems: 'flex-end', marginRight: '15px' }}>
                <Column style={{ marginRight: '15px' }}>
                  <Row style={{ alignItems: 'flex-end' }}>
                    <Button
                      type={TYPE_BUTTONS.BLUE}
                      onClick={() => MarketKuperApi.updateStocksAndPrices({ data: { shop: market } })}
                      style={{ marginTop: '10px', width: '100%' }}
                    >
                      Обновить цены от поставщика и остатки со склада
                    </Button>
                    <Button
                      type={TYPE_BUTTONS.RED}
                      onClick={() => MarketKuperApi.updateStocksAndPrices({ data: { shop: market, rules: { nullWarehouse: true } } })}
                      style={{ width: '100%', marginLeft: '15px' }}
                    >
                      Обнулить остатки
                    </Button>
                  </Row>
                </Column>
              </Row>

              <MarketProvidersDateUpdate providerData={providerData} />

              <Row style={{ marginTop: '10px' }}>

                {isOwner && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    onClick={() => MarketKuperApi.updateFeed({ data: { shop: market } })}
                  >
                    Обновить фид
                  </Button>
                )}

                {isOwner && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    style={{ marginLeft: '15px' }}
                    onClick={() => MarketKuperApi.updateFeedPrices({ data: { shop: market } })}
                  >
                    Обновить фид с ценами
                  </Button>
                )}

                {isOwner && (
                  <Button
                    type={TYPE_BUTTONS.WHITE}
                    style={{ marginLeft: '15px' }}
                    onClick={() => MarketKuperApi.updateFeedStocks({ data: { shop: market } })}
                  >
                    Обновить фид с остатками
                  </Button>
                )}
              </Row>
            </Column>
          </Row>
        </WhiteBlock>

        <KuperTable />
      </Content>
    </>
  );
};

export default KuperPage;
